if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.innrHTML = '<svg class="btn-cart-icon" width="32" height="29" viewBox="0 0 32 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.25023 22.2074C7.85217 22.136 7.8785 20.1696 9.25016 20.1013C13.1357 20.1148 23.384 20.1049 27.3931 20.1077C28.4896 20.1077 29.4277 19.3615 29.6743 18.2932L31.9508 8.43542C32.0812 7.871 31.9496 7.28681 31.5899 6.83276C31.2302 6.37871 30.6917 6.11463 30.1125 6.11463C28.4997 6.11463 14.8096 6.05266 7.79758 6.02471L6.68605 1.90045C6.41922 0.914866 5.51981 0.226562 4.49876 0.226562H0.937998C0.419973 0.226562 0 0.646536 0 1.16456C0 1.68259 0.419973 2.10256 0.937998 2.10256H4.49876C4.67455 2.10256 4.82932 2.22106 4.87503 2.38971L9.14386 18.2279C8.39327 18.2551 7.69415 18.5604 7.16399 19.0983C6.60695 19.6636 6.30779 20.4119 6.32161 21.2054C6.34925 22.7923 7.66301 24.0834 9.25023 24.0834H10.618C10.4147 24.5101 10.3005 24.9872 10.3005 25.4904C10.3005 27.3008 11.7733 28.7735 13.5837 28.7735C15.394 28.7735 16.8668 27.3008 16.8668 25.4904C16.8668 24.9871 16.7526 24.5101 16.5493 24.0834H22.4722C22.2691 24.51 22.155 24.9868 22.155 25.4899C22.155 27.3003 23.6278 28.773 25.4381 28.773C27.2484 28.773 28.7213 27.3002 28.7213 25.4899C28.7213 24.9672 28.5978 24.4729 28.3796 24.0338C28.7508 23.9088 29.0184 23.5587 29.0184 23.1454C29.0184 22.6274 28.5984 22.2074 28.0804 22.2074H9.25023ZM14.9907 25.4905C14.9907 26.2664 14.3595 26.8976 13.5836 26.8976C12.8077 26.8976 12.1765 26.2664 12.1765 25.4905C12.1765 24.715 12.8071 24.084 13.5824 24.0834H13.5848C14.3601 24.084 14.9907 24.715 14.9907 25.4905ZM25.4381 26.8971C24.6623 26.8971 24.031 26.2658 24.031 25.49C24.031 24.7218 24.65 24.0957 25.4153 24.0834H25.461C26.2264 24.0957 26.8454 24.7218 26.8454 25.49C26.8453 26.2658 26.2141 26.8971 25.4381 26.8971ZM30.1194 7.9975C30.1249 8.00451 30.1241 8.00782 30.1229 8.0132L29.1637 12.167H25.9156L26.4688 7.9758L30.105 7.99044C30.1106 7.99056 30.1139 7.99056 30.1194 7.9975ZM20.4489 18.2317V14.043H23.7758L23.223 18.2317H20.4489ZM15.7976 18.2317L15.2403 14.043H18.5729V18.2317H15.7976ZM11.4795 18.2317H11.4765C11.2479 18.2316 11.0465 18.0774 10.987 17.8577L9.95885 14.043H13.3477L13.905 18.2317H11.4795ZM14.9907 12.167L14.4265 7.92734L18.5729 7.94404V12.167H14.9907ZM20.4489 12.167V7.9516L24.5775 7.96824L24.0234 12.167H20.4489ZM12.533 7.91965L13.0981 12.167H9.45321L8.30385 7.90258L12.533 7.91965ZM27.3931 18.2317H25.1152L25.668 14.043H28.7305L27.8464 17.8711C27.7974 18.0834 27.611 18.2317 27.3931 18.2317Z" fill="white"/></svg>'+text;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
